"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewProductsLoader = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const preview_products_loader_constants_1 = require("./preview-products-loader.constants");
const preview_products_loader_styles_1 = require("./preview-products-loader.styles");
const catalog_1 = require("../client/catalog");
const components_1 = require("../components");
const localization_1 = require("../../localization");
const PreviewProductsLoader = ({ progress, progressState, error, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const value = progress * 100;
    return (react_1.default.createElement(preview_products_loader_styles_1.StyledProgressBarContainer, null, react_1.default.createElement("div", { className: "progress-bar-box" }, react_1.default.createElement(ui_components_1.Typography, { strong: true, variant: "body1" }, t({ key: preview_products_loader_constants_1.progressStateToMessageKeyMap[progressState] })), react_1.default.createElement(material_1.LinearProgress, { className: "progress-bar", variant: (value > 0 || error) ? 'determinate' : 'indeterminate', value: value }), progressState === catalog_1.CatalogProgressState.Error && error && react_1.default.createElement(components_1.Alert, { severity: "error" }, error))));
};
exports.PreviewProductsLoader = PreviewProductsLoader;
exports.default = exports.PreviewProductsLoader;
